export default {
  state: {
    models: [
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-muzhskaya-classic', // УНИКАЛЬНОЕ, модель
        title: 'Футболка мужская classic', // заголовок
        description: `<p>Классическая футболка с боковыми швами, с укрепляющей тесьмой по вороту. Край ворота в резинку с эластаном. Двойная прострочка по низу, на рукавах и на вороте спереди.</p>
        <p><strong>Плотность:</strong> 160 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> кулирная гладь (супрем), полотно малоусадочное, кардное</p>
        <p><strong>Размеры: </strong>XXS, XS, S, M, L, XL, XXL, 3XL, 4XL, 5XL; 6XL; 7XL; 8XL; 9XL; 10XL;</p>
        <p><strong>Воротник:</strong> круглый – О-ворот</p>
        <p><strong>Силуэт:</strong> прямой;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'male', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 2500, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'chocolate', 'dark-green', 'fuchsia', 'cyan', 'mustard', 'green',
          'emerald', 'jeans', 'khaki', 'red', 'azure', 'lime', 'melange', 'menthol',
          'sky', 'orange', 'peach', 'sand', 'gray', 'blue', 'lilac', 'plum',
          'dark-blue', 'terracotta', 'white', 'yellow',], // доступные цвета
        defaultColor: 'blue',
        image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/sinii.jpg`,
        slides: [
          {
            color: 'black',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/chernyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/chernyi-100x100.jpg`,
          },
          {
            color: 'burgundy',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/bordo.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/bordo-100x100.jpg`,
          },
          {
            color: 'chocolate',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/shokolad.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/shokolad-100x100.jpg`,
          },
          {
            color: 'dark-green',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/temno-zelenyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/temno-zelenyi-100x100.jpg`,
          },
          {
            color: 'fuchsia',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/fuksiia.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/fuksiia-100x100.jpg`,
          },
          {
            color: 'cyan',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/goluboi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/goluboi-100x100.jpg`,
          },
          {
            color: 'mustard',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/gorchitca.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/gorchitca-100x100.jpg`,
          },
          {
            color: 'green',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/zelenyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/zelenyi-100x100.jpg`,
          },
          {
            color: 'emerald',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/izumrud.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/izumrud-100x100.jpg`,
          },
          {
            color: 'jeans',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/dzhins.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/dzhins-100x100.jpg`,
          },
          {
            color: 'khaki',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/haki.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/haki-100x100.jpg`,
          },
          {
            color: 'red',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/krasnyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/krasnyi-100x100.jpg`,
          },
          {
            color: 'azure',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/lazur.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/lazur-100x100.jpg`,
          },
          {
            color: 'lime',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/laim.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/laim-100x100.jpg`,
          },
          {
            color: 'melange',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/melanzh.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/melanzh-100x100.jpg`,
          },
          {
            color: 'menthol',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/mentol.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/mentol-100x100.jpg`,
          },
          {
            color: 'sky',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/nebo.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/nebo-100x100.jpg`,
          },
          {
            color: 'orange',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/oranzhevyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/oranzhevyi-100x100.jpg`,
          },
          {
            color: 'peach',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/persik.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/persik-100x100.jpg`,
          },
          {
            color: 'sand',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/pesok.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/pesok-100x100.jpg`,
          },
          {
            color: 'gray',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/seryi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/seryi-100x100.jpg`,
          },
          {
            color: 'blue',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/sinii.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/sinii-100x100.jpg`,
          },
          {
            color: 'lilac',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/siren.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/siren-100x100.jpg`,
          },
          {
            color: 'plum',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/sliva.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/sliva-100x100.jpg`,
          },
          {
            color: 'dark-blue',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/temno-sinii.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/temno-sinii-100x100.jpg`,
          },
          {
            color: 'terracotta',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/terrakot.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/terrakot-100x100.jpg`,
          },
          {
            color: 'white',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/belyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/belyi-100x100.jpg`,
          },
          {
            color: 'yellow',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/zheltyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-muzhskaya-classic/zheltyi-100x100.jpg`,
          },
        ],
        sizes: ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 2, price: 350 },
          { from: 3, to: 5, price: 300 },
          { from: 6, to: 10, price: 270 },
          { from: 11, to: 20, price: 240 },
          { from: 21, to: 30, price: 220 },
          { from: 31, to: 50, price: 190 },
          { from: 51, to: 100, price: 175 },
          { from: 101, to: 250, price: 165 },
          { from: 251, to: 500, price: 160 },
          { from: 501, to: 1000, price: 158 },
          { from: 1001, to: 3000, price: 155 },
          { from: 3001, to: 5000, price: 152 },
          { from: 5001, to: 10000, price: 147 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-detskaya-classic', // УНИКАЛЬНОЕ, модель
        title: 'Футболка детская classic', // заголовок
        description: `<p><strong>Плотность:</strong> 160 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> кулирная гладь (супрем), полотно малоусадочное, кардное</p>
        <p><strong>Размеры:&nbsp;</strong>3-4л, 5-6л (XXXS), 7-8л (XXS), 9-11л (XS), 12-14л (S)</p>
        <p><strong>Воротник:</strong> круглый – О-ворот</p>
        <p><strong>Силуэт:</strong> прямой;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'children', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 2500, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'chocolate', 'dark-green', 'fuchsia', 'cyan', 'mustard', 'green',
          'emerald', 'jeans', 'khaki', 'red', 'azure', 'lime', 'melange', 'menthol',
          'sky', 'orange', 'peach', 'sand', 'gray', 'blue', 'lilac', 'plum',
          'dark-blue', 'terracotta', 'white', 'yellow',], // доступные цвета
        defaultColor: 'lime',
        image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/laim.jpg`,
        slides: [
          {
            color: 'black',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/chernaia.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/chernaia-100x100.jpg`,
          },
          {
            color: 'burgundy',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/bordo.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/bordo-100x100.jpg`,
          },
          {
            color: 'chocolate',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/shokolad.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/shokolad-100x100.jpg`,
          },
          {
            color: 'dark-green',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/temno-zelenyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/temno-zelenyi-100x100.jpg`,
          },
          {
            color: 'fuchsia',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/fuksiia.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/fuksiia-100x100.jpg`,
          },
          {
            color: 'cyan',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/goluboi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/goluboi-100x100.jpg`,
          },
          {
            color: 'mustard',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/gorchitca.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/gorchitca-100x100.jpg`,
          },
          {
            color: 'green',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/zelenyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/zelenyi-100x100.jpg`,
          },
          {
            color: 'emerald',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/izumrud.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/izumrud-100x100.jpg`,
          },
          {
            color: 'jeans',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/dzhins.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/dzhins-100x100.jpg`,
          },
          {
            color: 'khaki',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/haki.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/haki-100x100.jpg`,
          },
          {
            color: 'red',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/krasnaia.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/krasnaia-100x100.jpg`,
          },
          {
            color: 'azure',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/lazur.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/lazur-100x100.jpg`,
          },
          {
            color: 'lime',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/laim.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/laim-100x100.jpg`,
          },
          {
            color: 'melange',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/melanzh.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/melanzh-100x100.jpg`,
          },
          {
            color: 'menthol',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/mentol.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/mentol-100x100.jpg`,
          },
          {
            color: 'sky',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/nebo.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/nebo-100x100.jpg`,
          },
          {
            color: 'orange',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/oranzh.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/oranzh-100x100.jpg`,
          },
          {
            color: 'peach',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/persik.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/persik-100x100.jpg`,
          },
          {
            color: 'sand',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/pesok.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/pesok-100x100.jpg`,
          },
          {
            color: 'gray',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/seryi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/seryi-100x100.jpg`,
          },
          {
            color: 'blue',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/sinii.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/sinii-100x100.jpg`,
          },
          {
            color: 'lilac',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/siren.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/siren-100x100.jpg`,
          },
          {
            color: 'plum',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/sliva.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/sliva-100x100.jpg`,
          },
          {
            color: 'dark-blue',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/temno-sinii.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/temno-sinii-100x100.jpg`,
          },
          {
            color: 'terracotta',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/terrakot.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/terrakot-100x100.jpg`,
          },
          {
            color: 'white',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/belyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/belyi-100x100.jpg`,
          },
          {
            color: 'yellow',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/zheltyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-detskaya-classic/zheltyi-100x100.jpg`,
          },
        ],
        sizes: ['4xs', '3xs', '2xs', 'xs', 's'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 2, price: 300 },
          { from: 3, to: 5, price: 250 },
          { from: 6, to: 10, price: 220 },
          { from: 11, to: 30, price: 199 },
          { from: 31, to: 50, price: 180 },
          { from: 51, to: 100, price: 155 },
          { from: 101, to: 250, price: 140 },
          { from: 251, to: 500, price: 135 },
          { from: 501, to: 1000, price: 127 },
          { from: 1001, to: 3000, price: 120 },
          { from: 3001, to: 5000, price: 118 },
          { from: 5001, to: 10000, price: 115 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-zhenskaya-classic', // УНИКАЛЬНОЕ, модель
        title: 'Футболка женская classic', // заголовок
        description: `<p>Классическая &nbsp;кроеная футболка с боковыми швами, с укрепляющей тесьмой по вороту. Край ворота в резинку с эластаном. Двойная прострочка по низу, на рукавах и на вороте спереди. Приталенный силуэт.</p>
        <p><strong>Плотность:</strong> 160 г/м2;</p>
        <p><strong>Состав:</strong> 100% хлопок;</p>
        <p><strong>Тип полотна:</strong> кулирная гладь (супрем), полотно малоусадочное, кардное</p>
        <p><strong>Размеры:</strong>&nbsp;XS, S, M, L, XL, XXL</p>
        <p><strong>Воротник:</strong> круглый — О-ворот</p>
        <p><strong>Силуэт:</strong> приталенный;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp;Classic.</p>`,
        gender: 'female', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 2500, // минимальная сумма заказа
        colors: ['burgundy', 'chocolate', 'dark-green', 'fuchsia', 'cyan', 'mustard', 'green', 'emerald',
          'jeans', 'khaki', 'lime', 'sky', 'orange', 'peach', 'sand', 'gray',
          'blue', 'lilac', 'plum', 'dark-blue', 'terracotta', 'white', 'yellow',], // доступные цвета
        defaultColor: 'burgundy',
        image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/bordo.jpg`,
        slides: [
          {
            color: 'burgundy',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/bordo.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/bordo-100x100.jpg`,
          },
          {
            color: 'chocolate',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/shokolad.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/shokolad-100x100.jpg`,
          },
          {
            color: 'dark-green',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/temno-zelenyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/temno-zelenyi-100x100.jpg`,
          },
          {
            color: 'fuchsia',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/fuksiia.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/fuksiia-100x100.jpg`,
          },
          {
            color: 'cyan',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/goluboi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/goluboi-100x100.jpg`,
          },
          {
            color: 'mustard',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/gorchitca.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/gorchitca-100x100.jpg`,
          },
          {
            color: 'green',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/zelenyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/zelenyi-100x100.jpg`,
          },
          {
            color: 'emerald',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/izumrud.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/izumrud-100x100.jpg`,
          },
          {
            color: 'jeans',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/dzhins.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/dzhins-100x100.jpg`,
          },
          {
            color: 'khaki',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/haki.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/haki-100x100.jpg`,
          },
          {
            color: 'lime',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/laim.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/laim-100x100.jpg`,
          },
          {
            color: 'sky',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/nebo.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/nebo-100x100.jpg`,
          },
          {
            color: 'orange',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/oranzhevyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/oranzhevyi-100x100.jpg`,
          },
          {
            color: 'peach',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/persik.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/persik-100x100.jpg`,
          },
          {
            color: 'sand',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/pesok.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/pesok-100x100.jpg`,
          },
          {
            color: 'gray',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/seryi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/seryi-100x100.jpg`,
          },
          {
            color: 'blue',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/sinii.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/sinii-100x100.jpg`,
          },
          {
            color: 'lilac',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/siren.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/siren-100x100.jpg`,
          },
          {
            color: 'plum',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/sliva.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/sliva-100x100.jpg`,
          },
          {
            color: 'dark-blue',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/temno-sinii.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/temno-sinii-100x100.jpg`,
          },
          {
            color: 'terracotta',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/terrakot.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/terrakot-100x100.jpg`,
          },
          {
            color: 'white',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/belaia.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/belaia-100x100.jpg`,
          },
          {
            color: 'yellow',
            image: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/zheltyi.jpg`,
            thumb: `${process.env.BASE_URL}img/tShirts/futbolka-zhenskaya-classic/zheltyi-100x100.jpg`,
          },
        ],
        sizes: ['xs', 's', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
        { from: 0, to: 2, price: 350 },
        { from: 3, to: 5, price: 300 },
        { from: 6, to: 10, price: 270 },
        { from: 11, to: 20, price: 240 },
        { from: 21, to: 30, price: 220 },
        { from: 31, to: 50, price: 190 },
        { from: 51, to: 100, price: 175 },
        { from: 101, to: 250, price: 165 },
        { from: 251, to: 500, price: 160 },
        { from: 501, to: 1000, price: 158 },
        { from: 1001, to: 3000, price: 155 },
        { from: 3001, to: 5000, price: 152 },
        { from: 5001, to: 10000, price: 147 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-promo-light', // УНИКАЛЬНОЕ, модель
        title: 'Футболка промо-лайт', // заголовок
        description: `<p>Футболка промо-лайт бесшовная (некоторые модели с боковыми швами), с двойной прострочкой по вороту. Край ворота в резинку с эластаном. Двойная прострочка по низу, на рукавах и на вороте спереди. Прямой крой.<br>
        <strong>Плотность</strong>: 140 г/м2;<br>
        <strong>Состав</strong>: 100% хлопок;<br>
        <strong>Тип полотна</strong>: кулирная гладь, полотно малоусадочное, кардное<br>
        <strong>Размеры</strong>: S, M, L, XL, XXL<br>
        <strong>Воротник</strong>: круглый — О-ворот<br>
        <strong>Силуэт</strong>: прямой;<br>
        <strong>Крашение</strong>: активное;<br>
        <strong>Марка</strong>: PR-Tex&nbsp;Промо.`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'red', 'melange', 'orange', 'gray', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'blue',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/10/blue.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/black.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/black-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/red.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/red-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D0%BC%D0%B5%D0%BB%D0%B0%D0%BD%D0%B6.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/%D0%BC%D0%B5%D0%BB%D0%B0%D0%BD%D0%B6-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/2019/03/t-shirt_promo_orange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2019/03/t-shirt_promo_orange-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/gray.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/gray-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/blue.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/blue-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/dark-blue.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/dark-blue-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/white.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/white-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/10/yellow.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/10/yellow-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 5, price: 250 },
          { from: 6, to: 10, price: 210 },
          { from: 11, to: 30, price: 180 },
          { from: 31, to: 50, price: 165 },
          { from: 51, to: 100, price: 150 },
          { from: 101, to: 250, price: 135 },
          { from: 251, to: 500, price: 125 },
          { from: 501, to: 1000, price: 117 },
          { from: 1001, to: 3000, price: 110 },
          { from: 3001, to: 5000, price: 107 },
          { from: 5001, to: 10000, price: 105 },
          { from: 10001, to: 99999, price: 99 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-heavy', // УНИКАЛЬНОЕ, модель
        title: 'Футболка Премиум 180', // заголовок
        description: `<p><span style="font-weight: 400;">Футболка премиум качества повышенной плотности, с укрепляющей тесьмой по вороту. Край ворота в резинку с эластаном. Двойная прострочка по низу, на рукавах и на вороте спереди, усиленные плечевые швы. </span><br>
        <strong>Плотность</strong>: 180 г/м2;<br>
        <b>Состав:</b><span style="font-weight: 400;"> 100% суперчёсанный индийский хлопок высшего качества;</span><br>
        <b>Тип полотна:</b><span style="font-weight: 400;"> Кулирная гладь, кардная пряжа;</span><br>
        <strong>Размеры</strong>: S, M, L, XL, 2XL, 3XL;<br>
        <strong>Воротник</strong>: круглый — О-ворот&nbsp;<span style="font-weight: 400;">с добавлением лайкры и мягким компенсатором горловины;</span><br>
        <strong>Силуэт</strong>: прямой;<br>
        <strong>Крашение</strong>: активное, <span style="font-weight: 400;">суперстойкое</span>;<br>
        <strong>Марка</strong>: PR-Tex&nbsp;<span style="font-weight: 400;">Premium</span>.`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'burgundy', 'dark-green', 'cyan', 'green', 'red', 'gray', 'blue', 'dark-blue', 'white'], // доступные цвета
        defaultColor: 'black',
        image: 'https://pr-tex.ru/wp-content/uploads/black-6.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-6.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-6-100x100.jpg',
          },
          {
            color: 'burgundy',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_bordo.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_bordo-100x100.jpg',
          },
          {
            color: 'dark-green',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_dark-green.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_dark-green-100x100.jpg',
          },
          {
            color: 'cyan',
            image: 'https://pr-tex.ru/wp-content/uploads/goluboy-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/goluboy-3-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_green.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_green-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_red.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_red-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_gray.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_gray-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_siniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_siniy-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_temno-siniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_temno-siniy-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_white.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/premium-180_white-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl', '3xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 2, price: 450 },
          { from: 3, to: 5, price: 400 },
          { from: 6, to: 10, price: 350 },
          { from: 11, to: 30, price: 310 },
          { from: 31, to: 50, price: 300 },
          { from: 51, to: 100, price: 280 },
          { from: 101, to: 250, price: 260 },
          { from: 251, to: 500, price: 250 },
          { from: 501, to: 1000, price: 235 },
          { from: 1001, to: 3000, price: 225 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-s-elastanom', // УНИКАЛЬНОЕ, модель
        title: 'Футболка женская с эластаном (стрейч)', // заголовок
        description: `<p>Классическая бесшовная женская приталенная футболка, с укрепляющей тесьмой по вороту. Двойная прострочка по низу, на рукавах. Край ворота в резинку с эластаном.</p>
        <p><strong>Плотность:</strong> 180 г/м2;</p>
        <p><strong>Состав:</strong> 92% хлопок, 8% эластан;</p>
        <p><strong>Тип полотна:</strong> стрейч, кулирная гладь (супрем), полотно малоусадочное, гребенное (Penye)</p>
        <p><strong>Размеры:</strong>&nbsp;S, M, L, XL, XXL</p>
        <p><strong>Воротник:</strong> круглый — О-ворот</p>
        <p><strong>Силуэт:</strong> приталенный;</p>
        <p><strong>Крашение:</strong> активное, суперстойкое;</p>
        <p><strong>Марка:</strong> PR-Tex&nbsp; Classic.</p>`,
        gender: 'female', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'fuchsia', 'lime', 'peach', 'blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'lime',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_salat.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_black-600x600.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_black-100x100.jpg',
          },
          {
            color: 'fuchsia',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_pink.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_pink-100x100.jpg',
          },
          {
            color: 'lime',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_salat.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_salat-100x100.jpg',
          },
          {
            color: 'peach',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_korall.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_korall-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_vasilek.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_vasilek-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_beliy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_beliy-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_yellow.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/2018/08/stretch_yellow-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 10, price: 600 },
          { from: 11, to: 30, price: 500 },
          { from: 31, to: 50, price: 450 },
          { from: 51, to: 100, price: 400 },
          { from: 101, to: 250, price: 350 },
          { from: 251, to: 500, price: 330 },
          { from: 501, to: 1000, price: 320 },
          { from: 1001, to: 3000, price: 310 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-premium', // УНИКАЛЬНОЕ, модель
        title: 'Футболка Премиум', // заголовок
        description: `<p><span style="font-weight: 400;">Классическая бесшовная футболка, с укрепляющей тесьмой по вороту. Край ворота в резинку с эластаном. Двойная прострочка по низу, на рукавах и на вороте спереди, усиленные плечевые швы. </span><br>
        <strong>Плотность</strong>: 160 г/м2;<br>
        <b>Состав:</b><span style="font-weight: 400;"> 100% суперчёсанный индийский хлопок высшего качества;</span><br>
        <b>Тип полотна:</b><span style="font-weight: 400;"> Кулирная гладь (супрем), полотно малоусадочное, гребенное (PENYE);</span><br>
        <strong>Размеры</strong>: S, M, L, XL, 2XL;<br>
        <strong>Воротник</strong>: круглый — О-ворот&nbsp;<span style="font-weight: 400;">с добавлением лайкры и мягким компенсатором горловины;</span><br>
        <strong>Силуэт</strong>: прямой;<br>
        <strong>Крашение</strong>: активное, <span style="font-weight: 400;">суперстойкое</span>;<br>
        <strong>Марка</strong>: PR-Tex&nbsp;<span style="font-weight: 400;">Premium</span>.`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'cyan', 'green', 'red', 'gray', 'blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'yellow',
        image: 'https://pr-tex.ru/wp-content/uploads/yellow-5.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/black-6.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/black-6-100x100.jpg',
          },
          {
            color: 'cyan',
            image: 'https://pr-tex.ru/wp-content/uploads/goluboy-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/goluboy-3-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/green-2.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/green-2-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/red-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/red-3-100x100.jpg',
          },
          {
            color: 'gray',
            image: 'https://pr-tex.ru/wp-content/uploads/seriy-6.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/seriy-6-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/vasilek.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/vasilek-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/white-3.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/white-3-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/yellow-5.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/yellow-5-100x100.jpg',
          },
        ],
        sizes: ['s', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 2, price: 500 },
          { from: 3, to: 5, price: 400 },
          { from: 6, to: 10, price: 350 },
          { from: 11, to: 30, price: 300 },
          { from: 31, to: 50, price: 270 },
          { from: 51, to: 100, price: 260 },
          { from: 101, to: 250, price: 250 },
          { from: 251, to: 500, price: 240 },
          { from: 501, to: 1000, price: 230 },
          { from: 1001, to: 3000, price: 220 },
        ]
      },
      {
        type: 'tShirts', // тип изделия
        model: 'futbolka-promo', // УНИКАЛЬНОЕ, модель
        title: 'Футболка промо', // заголовок
        description: `<p>Промо футболка с боковыми швами, с укрепляющей тесьмой по вороту. Край ворота в резинку с эластаном. Двойная прострочка по низу, на рукавах и на вороте спереди. Прямой крой.<br>
        <strong>Плотность</strong>: 150-155 г/м2;<br>
        <strong>Состав</strong>: 100% хлопок;<br>
        <strong>Тип полотна</strong>: кулирная гладь (супрем), полотно малоусадочное, кардное<br>
        <strong>Размеры</strong>: XS, S, M, L, XL, XXL<br>
        <strong>Воротник</strong>: круглый — О-ворот<br>
        <strong>Силуэт</strong>: прямой;<br>
        <strong>Крашение</strong>: активное;<br>
        <strong>Марка</strong>: PR-Tex&nbsp;Промо.`,
        gender: 'unisex', // пол: 'male', 'female', 'unisex', 'children'
        minOrderAmount: 5000, // минимальная сумма заказа
        colors: ['black', 'green', 'red', 'melange', 'orange', 'blue', 'dark-blue', 'white', 'yellow'], // доступные цвета
        defaultColor: 'melange',
        image: 'https://pr-tex.ru/wp-content/uploads/2018/07/%D0%A4%D1%83%D1%82%D0%B1%D0%BE%D0%BB%D0%BA%D0%B0-%D0%BC%D1%83%D0%B6%D1%81-%D0%BF%D1%80%D0%BE%D0%BC%D0%BE-%D0%BC%D0%B5%D0%BB%D0%B0%D0%BD%D0%B6.jpg',
        slides: [
          {
            color: 'black',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_black.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_black-100x100.jpg',
          },
          {
            color: 'green',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_green.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_green-100x100.jpg',
          },
          {
            color: 'red',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_krasniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_krasniy-100x100.jpg',
          },
          {
            color: 'melange',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_melange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_melange-100x100.jpg',
          },
          {
            color: 'orange',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_orange.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_orange-100x100.jpg',
          },
          {
            color: 'blue',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_siniy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_siniy-100x100.jpg',
          },
          {
            color: 'dark-blue',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_temno-siniy-100x100.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_temno-siniy-100x100.jpg',
          },
          {
            color: 'white',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_beliy.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_beliy-100x100.jpg',
          },
          {
            color: 'yellow',
            image: 'https://pr-tex.ru/wp-content/uploads/promo_yellow-600x415.jpg',
            thumb: 'https://pr-tex.ru/wp-content/uploads/promo_yellow-100x100.jpg',
          },
        ],
        sizes: ['xs', 's', 'm', 'l', 'xl', '2xl'], // доступные размеры
        priceList: [ // from - кол-во "от", to кол-во "до" (включительно), price - цена за шт
          { from: 0, to: 10, price: 200 },
          { from: 11, to: 50, price: 170 },
          { from: 51, to: 100, price: 160 },
          { from: 101, to: 250, price: 150 },
          { from: 251, to: 500, price: 145 },
          { from: 501, to: 1000, price: 140 },
          { from: 1001, to: 3000, price: 135 },
          { from: 3001, to: 5000, price: 132 },
          { from: 5001, to: 10000, price: 130 },
        ]
      },


    ]
  },
  mutations: {},
  actions: {}
}